export default function SectionContact() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-primary-500">
      <div className="w-full max-w-[720px] mx-auto text-center">
        <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-background-50/20 mb-5">
          <i className="ri-send-plane-fill text-background-50 text-2xl"></i>
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          投稿爆料
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-[560px] mx-auto leading-relaxed">
          掌握独家内幕或一手爆料？欢迎通过投稿入口联系我们。
          所有投稿将经过严格审核，优质内容将获得首页推荐曝光。
        </p>

        <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-background-50/15 max-w-[480px] mx-auto">
          <div className="grid grid-cols-1 gap-4 text-left">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/20 shrink-0">
                <i className="ri-mail-line text-background-50 text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-background-50/60">投稿邮箱</p>
                <p className="text-sm text-background-50 font-medium">tips@51heiliao.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/20 shrink-0">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-background-50/60">微信客服</p>
                <p className="text-sm text-background-50 font-medium">wuyiheiliao</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}